export default __webpack_public_path__ + "static/media/type_13_7.d0bc04f6.svg";